import React from "react";
import Rankings from "../components/Rankings";

const RankingsPage = () => {
  return (
    <main className="bg-[#0a0a0d] min-h-screen">
      <div className="relative pt-44 pb-4 overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: "url(https://images.pexels.com/photos/19249701/pexels-photo-19249701.jpeg?auto=compress&cs=tinysrgb&w=1920)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0d]/50 via-[#0a0a0d]/85 to-[#0a0a0d]" />
      </div>
      <Rankings />
    </main>
  );
};

export default RankingsPage;
